import {useEffect, useRef, useState} from "react";
import {CustomButton, CustomButtonProject, CustomTextField, CustomTextFieldProject} from "./Home";
import {Box, CircularProgress, FormControl, Grid, MenuItem, RadioGroup, Select, styled, Typography, useMediaQuery, useTheme} from "@mui/material";
import {
    CustomCheckbox,
    CustomFormControlLabel,
    CustomIcon,
    CustomCheckedIcon,
    CustomRadio,
    CustomRadioIcon, CustomCheckedRadioIcon, CustomSquareRadioIcon, CustomCheckedSquareRadioIcon
} from "../mui-styles/styles";

import projectStyle from './Project.module.css';
import axios from "axios";
import {firebase} from "../firebase/clientApp";
import {useTranslation} from "react-i18next";
import { Trans } from 'react-i18next'
import i18n from 'i18next';

const HiddenInput = styled('input')({
    display: 'none',
});

const UploadContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
});

const API_URL = "https://moncler-contest-2024-api-226934379894.europe-west1.run.app"
//const API_URL = "https://nardo-dev-portatile-api.plesh.co"

function Project() {
    const { t } = useTranslation();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [userData, setUserData] = useState(null);

    const [formData, setFormData] = useState({
        nome: '',
        cognome: '',
        email: '',
        region: '',
        companyArea: '',
        projectName: '',
        descriptionShort: '',
        descriptionExtended: '',
        file: null,
        fileName:'select file',
        privacy: false,
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [showDisclaimer, setShowDisclaimer] = useState(true);

    const inputRef = useRef(null);

    const initializeData = (user) => {
        // Get user from firebase auth
        setLoading(true);
        setUserData(user);

        const fullName = user?.displayName?.trim() || "";
        const parts = fullName.split(/\s+/); // split su spazi multipli, più robusto
        const firstName = parts[0] || "";
        const lastName = parts.slice(1).join(" ") || ""; // tutto il resto unito

        setFormData((prevData) => ({
            ...prevData,
            nome: firstName,
            cognome: lastName,
            email: user.email
        }));
        setLoading(false);
    }

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user)
                initializeData(user)
        })
    }, [])

    // Gestisce il cambiamento per tutti i campi del form
    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));

        if (formErrors[name]) {
            setFormErrors((prevErrors) => {
                const { [name]: removedError, ...rest } = prevErrors;
                return rest;
            });
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'];
            if (!allowedTypes.includes(file.type)) {
                alert('Per favore, seleziona un file PDF o PPTX.');
                return;
            }

            const maxSize = 25 * 1024 * 1024; // 25MB in bytes
            if (file.size > maxSize) {
                alert('Il file supera la dimensione massima di 25MB.');
                return;
            }

            setFormData((prevData) => ({
                ...prevData,
                file: file,
                fileName: file.name
            }));

            if (formErrors.file) {
                setFormErrors((prevErrors) => {
                    const { file: removedError, ...rest } = prevErrors;
                    return rest;
                });
            }
        }
    };

    const handleClick = () => {
        inputRef.current.click();
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = {};

        if (!formData.nome.trim()) errors.nome = t('errors.nomeRequired');
        if (!formData.cognome.trim()) errors.cognome = t('errors.cognomeRequired');
        if (!formData.email.trim()) errors.email = t('errors.emailRequired');
        if (!formData.region) errors.region = t('errors.regionRequired');
        if (!formData.companyArea) errors.companyArea = t('errors.companyAreaRequired');
        if (!formData.projectName.trim()) errors.projectName = t('errors.projectNameRequired');
        if (!formData.descriptionShort.trim()) errors.descriptionShort = t('errors.descriptionShortRequired');
        if (!formData.file) errors.file = t('errors.fileRequired');
        if (!formData.privacy) errors.privacy = t('errors.privacyRequired');

        setFormErrors(errors);

        if (Object.keys(errors).length > 0) {
            return;
        }

        setLoading(true);

        const formDataToSend = new FormData();
        formDataToSend.append('nome', formData.nome);
        formDataToSend.append('cognome', formData.cognome);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('region', formData.region);
        formDataToSend.append('companyArea', formData.companyArea);
        formDataToSend.append('projectName', formData.projectName);
        formDataToSend.append('descriptionShort', formData.descriptionShort);
        formDataToSend.append('descriptionExtended', formData.descriptionExtended);
        formDataToSend.append('privacy', formData.privacy);
        formDataToSend.append('file', formData.file);

        axios.post(`${API_URL}/upload`, formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                console.info('Form inviato con successo', response);
                setSuccess(true);
                setLoading(false);
            })
            .catch(error => {
                console.info('Errore durante l\'invio del form', error);
                setLoading(false);
            });
    };

    const handleConfirm = () => {
        setShowDisclaimer(false);
    };



    return(
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            position: 'relative',
            overflowX:'hidden'
        }}>
            {success &&
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100vw',
                        height: '100vh',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative'
                    }}>
                    <img src={'/images/moncler-logo-black.svg'} className={projectStyle.logoSuccess}
                         style={{position:'absolute', top:'10vh'}}
                         alt={'Moncler Logo'}/>
                    <h2 style={{fontWeight: '400', marginTop: '0', marginBottom: 0, textAlign: 'center'}}>
                        Thank you for submitting your project!
                    </h2>

                </div>
            }

            {
                !success &&
                <div className={projectStyle.contentContainer}
                     style={{
                         display: 'flex',
                         flexDirection: 'column',
                         width: '100vw',
                         alignItems: 'flex-start',
                         justifyContent: 'flex-start',
                         position: 'relative',
                         paddingTop: '16px',
                     }}>
                    <img src={'/images/moncler-logo-black.svg'} className={projectStyle.logo}
                         style={{marginBottom: '5vh', marginTop: '5vh'}}
                         alt={'Moncler Logo'}/>

                    <img src={'/images/project-img.png'} className={projectStyle.image}
                         style={{width: '50%', position: 'absolute', right: '-5vw', top: '15%'}}
                         alt={'Moncler Img'}/>

                    <div className={projectStyle.welcomeText}>
                        <h2 style={{fontWeight: '400', marginTop: '0', marginBottom: 0}}>{t('welcomeTitle')} </h2>
                        <p style={{fontSize: '16px', marginTop: '1vh', fontWeight: '500', width:isMobile ? '100%' : '50%'}}>
                            <Trans i18nKey="welcomeText" components={{ br: <br /> }} />
                        </p>
                    </div>

                    <div className={projectStyle.formContainer}>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-start">
                                <Grid item xs={12} sm={6}>
                                    <CustomTextFieldProject
                                        name="nome"
                                        label=""
                                        type="text"
                                        placeholder={'Name'}
                                        variant="outlined"
                                        value={formData.nome}
                                        error={!!formErrors.nome}
                                        helperText={formErrors.nome}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomTextFieldProject
                                        name="cognome"
                                        label=""
                                        type="text"
                                        placeholder={'Last Name'}
                                        variant="outlined"
                                        value={formData.cognome}
                                        error={!!formErrors.cognome}
                                        helperText={formErrors.cognome}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomTextFieldProject
                                        disabled={userData?.email && userData?.email.length > 0}
                                        name="email"
                                        label=""
                                        type="email"
                                        placeholder={'Email'}
                                        variant="outlined"
                                        value={formData.email}
                                        error={!!formErrors.email}
                                        helperText={formErrors.email}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth error={!!formErrors.region}>
                                        <Select
                                            name="region"
                                            value={formData.region}
                                            onChange={handleChange}
                                            displayEmpty
                                            sx={{
                                                backgroundColor: '#fff',
                                                borderRadius: 0,
                                                fontFamily: "'MonclerGothic', sans-serif",
                                                fontSize: '16px',
                                                '& .MuiSelect-select': {
                                                    padding: '8px',
                                                    color: formData.region ? '#000' : '#000',
                                                    fontWeight: formData.region ? 'normal' : '600',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: formErrors.region ? '#d6413f' : 'rgba(0,0,0,0.23)',
                                                    borderRadius: 0,
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#000',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#000',
                                                },
                                            }}
                                        >
                                            <MenuItem value="" disabled sx={{fontFamily: "'MonclerGothic', sans-serif", fontSize: '16px', fontWeight: '600'}}>Region</MenuItem>
                                            {['HQ', 'APAC', 'Chinese Mainland', 'Japan', 'Korea', 'Americas', 'Emea'].map((r) => (
                                                <MenuItem key={r} value={r} sx={{fontFamily: "'MonclerGothic', sans-serif", fontSize: '16px'}}>{r}</MenuItem>
                                            ))}
                                        </Select>
                                        {formErrors.region && (
                                            <Typography style={{color: '#d6413f', marginTop: '4px', fontSize: '12px', marginLeft: '16px'}}>
                                                {formErrors.region}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Box>
                                <h2 style={{fontWeight: '400', marginBottom: 0}}>{t('companyArea')}</h2>
                                <p style={{fontSize: '16px', marginTop: '1vh', fontWeight: '500'}}>
                                    {t('companyAreaSub')}
                                </p>
                                <RadioGroup
                                    value={formData.companyArea}
                                    onChange={handleChange}
                                    row // Disporre le caselle in fila orizzontale
                                >
                                    <Grid container spacing={3} justifyContent="space-between" alignItems="center">
                                        {['Marketing', 'People', 'Sustainability', 'Digital', 'Retail', 'Supply chain', 'Product & Others'].map((label, index) => (
                                            <Grid item key={index}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start'
                                                }}>
                                                <span style={{
                                                    fontFamily: "'MonclerGothic', sans-serif",
                                                    fontSize: '16px',
                                                    marginBottom: '1vh',
                                                    fontWeight: '500'
                                                }}>
                                                {label}
                                                </span>
                                                    <CustomRadio
                                                        icon={<CustomSquareRadioIcon/>}
                                                        checkedIcon={<CustomCheckedSquareRadioIcon/>}
                                                        value={label}
                                                        name="companyArea"
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </RadioGroup>
                                {formErrors.companyArea && (
                                    <Typography style={{
                                        color: '#d6413f',
                                        marginTop: '8px',
                                        fontSize: '12px',
                                        marginLeft: '16px'
                                    }}>
                                        {formErrors.companyArea}
                                    </Typography>
                                )}
                            </Box>

                            <Box>
                                <h2 style={{fontWeight: '400', marginBottom: '1vh'}}>{t('projectTitle')} <span
                                    style={{fontSize: '14px', fontWeight: 'normal'}}> {t('projectTitleMax')} </span></h2>
                                <CustomTextFieldProject
                                    name="projectName"
                                    label=""
                                    type="text"
                                    variant="outlined"
                                    value={formData.projectName}
                                    error={!!formErrors.projectName}
                                    helperText={formErrors.projectName}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 120}}
                                >
                                </CustomTextFieldProject>
                            </Box>

                            <Box>
                                <h2 style={{fontWeight: '400', marginBottom: 0}}>{t('shortDescription')}
                                    {/*<span
                                    style={{fontSize: '14px', fontWeight: 'normal'}}> (Max 800 characters) </span>*/}
                                </h2>
                                <p style={{fontSize: '16px', marginTop: '1vh', fontWeight: '500'}}>
                                    {t('shortDescriptionSub')}
                                </p>
                                <CustomTextFieldProject
                                    name="descriptionShort"
                                    label=""
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={2}
                                    value={formData.descriptionShort}
                                    error={!!formErrors.descriptionShort}
                                    helperText={formErrors.descriptionShort}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 800}}
                                >
                                </CustomTextFieldProject>
                            </Box>

                            <Box>
                                <h2 style={{fontWeight: '400', marginBottom: '1vh'}}>{t('longDescription')}<span
                                    style={{fontSize: '14px', fontWeight: 'normal'}}> {t('longDescriptionMax')} </span></h2>
                                {/*<p style={{fontSize: '16px', marginTop: '1vh', fontWeight: '500'}}>
                                    Describe your idea in depth.
                                </p>*/}
                                <CustomTextFieldProject
                                    name="descriptionExtended"
                                    label=""
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={formData.descriptionExtended}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 2000}}
                                >
                                </CustomTextFieldProject>
                            </Box>

                            <Box>
                                <h2 style={{fontWeight: '400', marginBottom: '1vh'}}>{t('fileUpload')} <span
                                    style={{fontSize: '14px', fontWeight: 'normal'}}> (PDF / PPTX Max 25MB) </span></h2>
                                <UploadContainer>
                                    <CustomTextFieldProject
                                        variant="outlined"
                                        value={formData.fileName}
                                        error={!!formErrors.file}
                                        helperText={formErrors.file}
                                        onClick={handleClick}
                                        InputProps={{
                                            readOnly: true,
                                            style: {cursor: 'pointer'},
                                        }}
                                    />
                                    <CustomButtonProject onClick={handleClick}
                                                         sx={!!formErrors.file ? {marginBottom: '22px'} : {marginBottom: '0px'}}>
                                        UPLOAD
                                    </CustomButtonProject>
                                    <HiddenInput
                                        ref={inputRef}
                                        type="file"
                                        accept=".pdf, .pptx"
                                        onChange={handleFileChange}
                                    />
                                </UploadContainer>
                            </Box>
                            <Box sx={{marginTop: '3vh'}}>
                                <CustomFormControlLabel
                                    control={
                                        <CustomCheckbox
                                            name='privacy'
                                            disableRipple
                                            color="default"
                                            checked={formData.privacy}
                                            onChange={handleChange}
                                            icon={<CustomIcon/>}
                                            checkedIcon={<CustomCheckedIcon/>}
                                        />
                                    }
                                    label={<span style={{marginLeft: '16px'}}>
                                        <Trans
                                            i18nKey="privacy"
                                            components={[
                                                <a href="/privacy-policy.pdf" target="_blank" rel="noopener noreferrer" style={{textDecoration:'underline'}} />
                                            ]}
                                        />
                                    </span>}
                                    sx={{ alignItems: 'flex-start' }}
                                />
                                {formErrors.privacy && (
                                    <Typography style={{
                                        color: '#d6413f',
                                        marginTop: '8px',
                                        fontSize: '12px',
                                        marginLeft: '16px'
                                    }}>
                                        {formErrors.privacy}
                                    </Typography>
                                )}
                            </Box>

                            <Box className={projectStyle.buttonContainer} sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '5vh',
                                marginBottom: '5vh'
                            }}>
                                {loading ?
                                    <CircularProgress color={'black'}></CircularProgress>
                                    :
                                    <CustomButtonProject type='submit'>
                                        {t('shareIdea')}
                                    </CustomButtonProject>}
                            </Box>


                        </form>

                    </div>
                </div>
            }


        {showDisclaimer && (
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1300,
                    padding: '16px',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        width: '100%',
                        maxWidth: '600px',
                        maxHeight: '80vh',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                    }}
                >

                    {/* Scrollable content */}
                    <div style={{
                        overflowY: 'auto',
                        padding: '32px 32px 24px 32px',
                        fontFamily: "'MonclerGothic', sans-serif",
                        fontSize: '13px',
                        lineHeight: '1.6',
                        color: '#000',
                    }}>
                        <p style={{fontWeight: '700', marginTop: 0, marginBottom: '8px'}}>Intellectual Property Rights</p>
                        <p style={{marginTop: 0}}>To the fullest extent permitted by applicable law and at no additional cost or consideration beyond the Employee's existing remuneration or benefits:</p>
                        <p style={{marginTop: 0}}>(a) the Employee hereby irrevocably assigns and transfers to the Company, which may in turn assign or license such rights within the Group or to third parties, all present and future economic and intellectual property rights in and to the Content, on an exclusive, worldwide basis, for the entire duration of such rights and for any and all forms of exploitation (whether known now or developed in the future); and</p>
                        <p style={{marginTop: 0}}>(b) such assignment includes, without limitation, all rights of reproduction, fixation, adaptation, modification, translation, distribution, communication to the public, making available, display, performance, marketing, licensing, sub‑licensing and any other form of use, as well as the right to authorize third parties to do any of the foregoing.</p>

                        <p style={{fontWeight: '700', marginBottom: '8px'}}>2. Content usage</p>
                        <p style={{marginTop: 0}}>2.1. The above assignment applies to all Content uploaded to the Platform, whether or not such Content is selected, implemented or developed by the Company or any other Group entity. The Employee acknowledges and agrees that, once the Content has been submitted through the Platform, the Employee shall not use, exploit, license, assign or otherwise dispose of the same or substantially similar Content for their own benefit or for the benefit of any third party, unless the Company has given its prior written consent.</p>
                        <p style={{marginTop: 0}}>2.2. The Company and the Group shall have no obligation to review, select, implement, develop, commercialize or otherwise use any Content submitted through the Platform.</p>

                        <p style={{fontWeight: '700', marginBottom: '8px'}}>3. No Conflict with Employment and / or other agreements</p>
                        <p style={{marginTop: 0}}>The Employee expressly acknowledges and agrees that, notwithstanding any provision in their employment, consultancy or similar agreement which limits the Company's ownership of inventions or creative works developed in the Employee's own time and/or without the use of company equipment or resources, any Content submitted through the Platform shall be owned by the Company as set out in this disclaimer. In case of any conflict or inconsistency between this clause and any such provision, this disclaimer shall prevail exclusively with respect to the Content submitted through the Platform.</p>

                        <p style={{fontWeight: '700', marginBottom: '8px'}}>4. Moral Rights</p>
                        <p style={{marginTop: 0}}>4.1. Nothing in these disclaimer is intended to, and shall not be construed to, assign or waive any moral rights (or similar inalienable rights) that the Employee may hold in the Content under applicable law. Such moral rights shall remain with the Employee.</p>
                        <p style={{marginTop: 0}}>4.2. However, the Employee acknowledges that the Company and the Group may, in exercising the economic and intellectual property rights assigned under this clause, adapt, modify or combine the Content with other materials and use the Content in different contexts, formats and media, to the extent permitted by applicable law and without prejudice to the Employee's moral rights.</p>

                        <p style={{fontWeight: '700', marginBottom: '8px'}}>5. Further Assurances</p>
                        <p style={{marginTop: 0, marginBottom: 0}}>Without prejudice to the above, the Employee undertakes, if necessary, whenever reasonably requested by the Company and at the Company's expense, to sign any additional documents and to take any further actions that may be reasonably necessary or desirable to confirm, evidence, register or perfect the assignment of rights set out in this clause and to enable the Company and/or any other Group entity to fully exercise and enforce such rights anywhere in the world.</p>
                    </div>

                    {/* CONFIRM button */}
                    <div style={{
                        padding: '16px 32px 24px 32px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        flexShrink: 0,
                    }}>
                        <CustomButtonProject onClick={handleConfirm}>
                            ACCEPTED AND SIGNED
                        </CustomButtonProject>
                    </div>
                </div>
            </div>
        )}
        </div>
    )
}

export default Project;
